import { BASE_URL } from "../../Environment/config"
import { httpClient } from "../../Http/client";

export const resetPassword = async (email) => {
    const url = `${BASE_URL}/forgot-password`;
    
    const data = {
        email: email,
        role: "CUSTOMER"
    };

    const { data: resetData } = await httpClient.post(url, data);
    return resetData;
}
